<div class="d-flex h-100 text-center">
    <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
        <app-navigation/>

        <main class="px-3">
            <div class="price-container">
                <h1 class="display-4 mb-4">Preise</h1>
                <p class="lead mb-5">Transparente Pakete – Preis pro QR-Code und Jahr.</p>

                <div class="row g-4 justify-content-center">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="card price-card h-100 shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title">50 QR-Codes <span
                                    class="badge rounded-pill text-bg-secondary ms-2">Klein</span></h5>
                                <p class="card-text price">€9<span class="per">/Code/Jahr</span></p>
                                <ul class="list-unstyled mb-4">
                                    <li>Ideal für kleine Hausverwaltungen oder Betriebe mit wenigen Maschinen und
                                        Geräten
                                    </li>
                                </ul>
                                <button class="btn btn-warning" (click)="openContact('Klein (50 QR-Codes)')">Anfragen
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="card price-card h-100 shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title">150 QR-Codes <span
                                    class="badge rounded-pill text-bg-primary ms-2">Mittel</span></h5>
                                <p class="card-text price">€8<span class="per">/Code/Jahr</span></p>
                                <ul class="list-unstyled mb-4">
                                    <li>Optimiert für mittelgroße Hausverwaltungen und Unternehmen mit Maschinenpark
                                    </li>
                                </ul>
                                <button class="btn btn-warning" (click)="openContact('Mittel (150 QR-Codes)')">Anfragen
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="card price-card h-100 shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title">300 QR-Codes <span
                                    class="badge rounded-pill text-bg-success ms-2">Groß</span></h5>
                                <p class="card-text price">€7<span class="per">/Code/Jahr</span></p>
                                <ul class="list-unstyled mb-4">
                                    <li>Für große Hausverwaltungen und Unternehmen mit vielen Maschinen und Geräten</li>
                                </ul>
                                <button class="btn btn-warning" (click)="openContact('Groß (300 QR-Codes)')">Anfragen
                                </button>
                            </div>
                        </div>
                    </div>


                    <div class="col-12 col-md-12 col-lg-12">
                        <div class="card price-card h-100 shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title">Mehr als 300 QR-Codes</h5>
                                <p class="card-text price">Individuelles Angebot</p>
                                <ul class="list-unstyled mb-4">
                                    <li>Kontaktieren Sie uns für ein maßgeschneidertes Angebot</li>
                                </ul>
                                <a class="btn btn-warning" (click)="openContact('Individuell (Mehr als 300 QR-Codes)')">Anfragen</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <!-- Kontaktformular Modal -->
        <div bsModal #contactModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
             aria-labelledby="contactModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="contactModalLabel">Angebot anfordern</h4>
                        <button type="button" class="btn-close" aria-label="Close"
                                (click)="contactModal.hide()"></button>
                    </div>
                    <form #contactForm="ngForm" *ngIf="true">
                        <div class="modal-body">
                            <div class="alert alert-info small mb-3">
                                Sie erhalten ein Angebot innerhalb von 24h. Die Einrichtung und Versand der Sticker
                                erfolgt direkt nach Auftragserteilung.
                            </div>

                            <div class="mb-3 text-start">
                                <label class="form-label">Firma</label>
                                <input type="text" class="form-control" name="company" ngModel required>
                            </div>
                            <div class="mb-3 text-start">
                                <label class="form-label">Anschrift</label>
                                <input type="text" class="form-control" name="address" ngModel required placeholder="Straße, Hausnummer, PLZ, Ort">
                            </div>
                            <div class="mb-3 text-start">
                                <label class="form-label">Ansprechpartner</label>
                                <input type="text" class="form-control" name="contact" ngModel required>
                            </div>
                            <div class="mb-3 text-start">
                                <label class="form-label">E-Mail</label>
                                <input type="email" class="form-control" name="email" ngModel required>
                            </div>
                            <div class="mb-3 text-start">
                                <label class="form-label">Paket</label>
                                <select class="form-select" name="plan" [(ngModel)]="selectedPlan" required>
                                    <option [ngValue]="''" disabled selected>Bitte Paket wählen</option>
                                    <option *ngFor="let plan of plans" [ngValue]="plan">{{ plan }}</option>
                                </select>
                            </div>
                            <div class="mb-3 text-start">
                                <label class="form-label">Nachricht (optional)</label>
                                <textarea class="form-control" rows="3" name="message" ngModel></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" (click)="contactModal.hide()">Abbrechen
                            </button>
                            <button type="button" class="btn btn-success" (click)="sendRequest(contactForm)"
                                    [disabled]="contactForm?.invalid">Angebot anfordern
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <footer class="mt-auto">
            <p>Ein Produkt der <a href="https://www.noteradar.at/" class="text-black fw-bold" target="_blank">NoteRadar
                GmbH</a></p>
        </footer>
    </div>
</div>
